import { ctx } from './ctx.js';
import { wf } from './state.js';
import { apiGet } from './api.js';
import { TBL_CONCEPT, TBL_CONCEPT_UNIT, TBL_CONCEPT_LEVEL, TBL_ROOMS } from './constants.js';
import { fmt } from './utils.js';
import { buildSectionNode } from './builders.js';

var TBL_CRITERIA = 'tblc8Ckf8rR5aNKGP';
var TBL_PARCELS  = 'tblBcOe6dw3wSlave';
var TBL_SPECS    = 'tblrCqmsGbBCTldzZ';

/* ── Loaders ────────────────────────────────────────────────────────────── */
export function loadConcepts(cb) {
  if (ctx.conceptCache !== null) { if (cb) cb(); return; }
  ctx.conceptCache = [];
  var formula = 'FIND("' + ctx.recordId + '",ARRAYJOIN({Project Record UID (from Project)},","))';
  var qs = 'filterByFormula=' + encodeURIComponent(formula) + '&maxRecords=20';
  apiGet(TBL_CONCEPT, qs, function(d) {
    ctx.conceptCache = d ? d.records : [];
    if (cb) cb();
    ctx.refreshRootChildren('design');
  });
}

export function loadUnits(conceptId, cb) {
  var unitCache = ctx.unitCache;
  if (unitCache[conceptId] !== null && unitCache[conceptId] !== undefined) { if (cb) cb(); return; }
  unitCache[conceptId] = null;
  apiGet(TBL_CONCEPT_UNIT, 'maxRecords=200', function(d) {
    unitCache[conceptId] = (d ? d.records : []).filter(function(r) {
      var linked = r.fields['Project Concept'] || [];
      return linked.indexOf(conceptId) !== -1;
    });
    if (cb) cb();
    ctx.render();
  });
}

export function loadLevels(unitId, cb) {
  var levelCache = ctx.levelCache;
  if (levelCache[unitId] !== undefined && levelCache[unitId] !== null) { if (cb) cb(); return; }
  levelCache[unitId] = null;
  var formula = 'FIND("' + unitId + '",ARRAYJOIN({Record ID (from Concept Unit)},","))';
  var qs = 'filterByFormula=' + encodeURIComponent(formula) + '&maxRecords=20';
  apiGet(TBL_CONCEPT_LEVEL, qs, function(d) {
    var recs = d ? d.records : [];
    recs.sort(function(a, b) {
      return (a.fields['Stacking Order'] || 0) - (b.fields['Stacking Order'] || 0);
    });
    levelCache[unitId] = recs;
    if (cb) cb();
    ctx.render();
  });
}

export function loadRooms(levelId, cb) {
  var roomCache = ctx.roomCache;
  var unitCache = ctx.unitCache;
  var levelCache = ctx.levelCache;
  if (roomCache[levelId] !== undefined && roomCache[levelId] !== null) { if (cb) cb(); return; }
  roomCache[levelId] = null;
  var conceptId = '';
  Object.keys(unitCache).forEach(function(cid) {
    (unitCache[cid] || []).forEach(function(unit) {
      (levelCache[unit.id] || []).forEach(function(lev) {
        if (lev.id === levelId) conceptId = cid;
      });
    });
  });
  var formula = conceptId
    ? 'FIND("' + conceptId + '",ARRAYJOIN({Record UID (from Project Concept)},","))'
    : 'FALSE()';
  var qs = 'filterByFormula=' + encodeURIComponent(formula) + '&maxRecords=200';
  apiGet(TBL_ROOMS, qs, function(d) {
    var recs = (d ? d.records : []).filter(function(r) {
      var linked = r.fields['Concept Level'] || [];
      return linked.indexOf(levelId) !== -1;
    });
    recs.sort(function(a, b) {
      var an = a.fields['Room Number'] || '';
      var bn = b.fields['Room Number'] || '';
      return an < bn ? -1 : an > bn ? 1 : 0;
    });
    roomCache[levelId] = recs;
    if (cb) cb();
    ctx.render();
  });
}

export function loadUnassignedRooms(conceptId, cb) {
  var unassignedRoomsCache = ctx.unassignedRoomsCache;
  if (unassignedRoomsCache[conceptId] !== null && unassignedRoomsCache[conceptId] !== undefined) { if (cb) cb(); return; }
  unassignedRoomsCache[conceptId] = null;
  var formula = 'AND(FIND("' + conceptId + '",ARRAYJOIN({Record UID (from Project Concept)},",")),{Concept Level}=BLANK())';
  var qs = 'filterByFormula=' + encodeURIComponent(formula) + '&maxRecords=200';
  apiGet(TBL_ROOMS, qs, function(d) {
    var recs = d ? d.records : [];
    recs.sort(function(a, b) {
      return (a.fields['Room Number'] || '') < (b.fields['Room Number'] || '') ? -1 : 1;
    });
    unassignedRoomsCache[conceptId] = recs;
    if (cb) cb();
    ctx.render();
  });
}

function loadCriteria(cb) {
  if (ctx.criteriaCache !== null) { if (cb) cb(); return; }
  ctx.criteriaCache = [];
  var formula = 'FIND("' + ctx.recordId + '",ARRAYJOIN({Project Record UID (from Project)},","))';
  var qs = 'filterByFormula=' + encodeURIComponent(formula) + '&maxRecords=10';
  apiGet(TBL_CRITERIA, qs, function(d) {
    ctx.criteriaCache = d ? d.records : [];
    if (cb) cb();
    ctx.refreshRootChildren('design');
  });
}

function loadParcels(cb) {
  if (ctx.parcelsCache !== null) { if (cb) cb(); return; }
  ctx.parcelsCache = [];
  var formula = 'FIND("' + ctx.recordId + '",ARRAYJOIN({Project Record UID (from Project)},","))';
  var qs = 'filterByFormula=' + encodeURIComponent(formula) + '&maxRecords=20';
  apiGet(TBL_PARCELS, qs, function(d) {
    ctx.parcelsCache = d ? d.records : [];
    if (cb) cb();
    ctx.refreshRootChildren('design');
  });
}

function loadSpecs(cb) {
  if (ctx.specsCache !== null) { if (cb) cb(); return; }
  ctx.specsCache = [];
  var formula = 'FIND("' + ctx.recordId + '",ARRAYJOIN({Project Record UID (from Project) (from Project Concepts)},","))';
  var qs = 'filterByFormula=' + encodeURIComponent(formula) + '&maxRecords=20';
  apiGet(TBL_SPECS, qs, function(d) {
    ctx.specsCache = d ? d.records : [];
    if (cb) cb();
    ctx.refreshRootChildren('design');
  });
}

/* ── Renderers ──────────────────────────────────────────────────────────── */
export function buildDesignChildren() {
  var h = '';

  var criteriaInner = '';
  if (ctx.criteriaCache === null) {
    criteriaInner = '<div class="wf-loading">Loading criteria...</div>';
    loadCriteria();
  } else if (ctx.criteriaCache.length === 0) {
    criteriaInner = '<div class="wf-loading" style="color:#7a9aaa;">No criteria defined</div>';
  } else {
    for (var ci0 = 0; ci0 < ctx.criteriaCache.length; ci0++) {
      var crf = ctx.criteriaCache[ci0].fields;
      var crName = crf['Name'] || ctx.criteriaCache[ci0].id;
      var crToInclude = crf['To Include'] || '';
      criteriaInner += '<div class="wf-node wf-node--item"><div class="wf-row">';
      criteriaInner += '<span class="wf-triangle-spacer wf-triangle-spacer--hidden"></span>';
      criteriaInner += '<span class="wf-bullet wf-bullet--item"></span>';
      criteriaInner += '<div class="wf-text-wrap"><span class="wf-node-text">' + crName + '</span>';
      if (crToInclude) criteriaInner += '<span class="wf-status-pill" style="color:#1D9E75;border-color:#1D9E7533;">Criteria set</span>';
      criteriaInner += '</div></div></div>';
    }
  }
  h += buildSectionNode('design', 'criteria', 'Criteria', criteriaInner, ctx.criteriaCache ? ctx.criteriaCache.length : null);

  var parcelsInner = '';
  if (ctx.parcelsCache === null) {
    parcelsInner = '<div class="wf-loading">Loading parcels...</div>';
    loadParcels();
  } else if (ctx.parcelsCache.length === 0) {
    parcelsInner = '<div class="wf-loading" style="color:#7a9aaa;">No parcels</div>';
  } else {
    for (var pi = 0; pi < ctx.parcelsCache.length; pi++) {
      var pf = ctx.parcelsCache[pi].fields;
      var pName = pf['APN'] || pf['Name'] || pf['Parcel Name'] || ctx.parcelsCache[pi].id;
      var pZone = pf['Zone'] || '';
      parcelsInner += '<div class="wf-node wf-node--item"><div class="wf-row">';
      parcelsInner += '<span class="wf-triangle-spacer wf-triangle-spacer--hidden"></span>';
      parcelsInner += '<span class="wf-bullet wf-bullet--item"></span>';
      parcelsInner += '<div class="wf-text-wrap"><span class="wf-node-text">' + pName + '</span>';
      if (pZone) parcelsInner += '<span class="wf-status-pill">' + pZone + '</span>';
      parcelsInner += '</div></div></div>';
    }
  }
  h += buildSectionNode('design', 'parcels', 'Parcels', parcelsInner, ctx.parcelsCache ? ctx.parcelsCache.length : null);

  var conceptsInner = '';
  if (ctx.conceptCache === null) {
    conceptsInner = '<div class="wf-loading">Loading concepts...</div>';
    loadConcepts();
  } else if (ctx.conceptCache.length === 0) {
    conceptsInner = '<div class="wf-loading" style="color:#7a9aaa;">No concepts</div>';
  } else {
    for (var ci = 0; ci < ctx.conceptCache.length; ci++) {
      conceptsInner += buildConceptRow(ctx.conceptCache[ci], 'design');
    }
  }
  h += buildSectionNode('design', 'concepts', 'Concepts', conceptsInner, ctx.conceptCache ? ctx.conceptCache.length : null);

  var specsInner = '';
  if (ctx.specsCache === null) {
    specsInner = '<div class="wf-loading">Loading specifications...</div>';
    loadSpecs();
  } else if (ctx.specsCache.length === 0) {
    specsInner = '<div class="wf-loading" style="color:#7a9aaa;">No specifications</div>';
  } else {
    for (var si = 0; si < ctx.specsCache.length; si++) {
      var sf = ctx.specsCache[si].fields;
      var sName = sf['Name'] || ctx.specsCache[si].id;
      var sStatus = sf['Status'] || '';
      var sQuality = sf['Quality Grade'] || '';
      var sVersion = sf['Version Number'] ? 'v' + sf['Version Number'] : '';
      var sIssueDate = sf['Issue Date'] ? fmt(sf['Issue Date']) : '';
      var sStatusColor = (sStatus.indexOf('Posted') !== -1) ? '#1D9E75' : '#7a9aaa';
      specsInner += '<div class="wf-node wf-node--item"><div class="wf-row">';
      specsInner += '<span class="wf-triangle-spacer wf-triangle-spacer--hidden"></span>';
      specsInner += '<span class="wf-bullet wf-bullet--item"></span>';
      specsInner += '<div class="wf-text-wrap"><span class="wf-node-text">' + sName + '</span>';
      specsInner += '<span class="wf-meta">';
      if (sStatus) specsInner += '<span class="wf-status-pill" style="color:' + sStatusColor + ';border-color:' + sStatusColor + '33;">' + sStatus + '</span>';
      if (sQuality) specsInner += '<span class="wf-badge wf-badge--gray">' + sQuality + '</span>';
      if (sVersion) specsInner += '<span class="wf-date-btn" style="pointer-events:none;">' + sVersion + '</span>';
      if (sIssueDate) specsInner += '<span class="wf-date-btn" style="pointer-events:none;">' + sIssueDate + '</span>';
      specsInner += '</span></div></div></div>';
    }
  }
  h += buildSectionNode('design', 'specs', 'Specifications', specsInner, ctx.specsCache ? ctx.specsCache.length : null);

  return h;
}

export function buildConceptRow(concept, owner) {
  var f         = concept.fields;
  var cid       = concept.id;
  var cname     = f['Parti Pris Title'] || 'Unnamed Concept';
  var cSelected = f['Selected Concept'] === true;
  var ckey      = 'concept:' + cid + ':' + owner;
  var isCollapsed = wf.collapsed[ckey] !== false;
  var units       = ctx.unitCache[cid];
  var hasChildren = units === null || units === undefined || units.length > 0;
  var h = '';
  h += '<div class="wf-node wf-node--concept" data-key="' + ckey + '"><div class="wf-row">';
  if (hasChildren) {
    h += '<button class="wf-triangle' + (isCollapsed ? '' : ' wf-triangle--open') + '" data-fn="toggleCollapse" data-key="' + ckey + '">'
      + '<span class="wf-tri-icon ' + (isCollapsed ? 'wf-tri-icon--right' : 'wf-tri-icon--down') + '"></span></button>';
  } else {
    h += '<span class="wf-triangle-spacer wf-triangle-spacer--hidden"></span>';
  }
  h += '<button class="wf-bullet wf-bullet--concept" data-fn="zoomTo" data-level="concept-detail" data-conceptid="' + cid + '" title="Zoom into concept"></button>';
  h += '<div class="wf-text-wrap">';
  h += '<span class="wf-node-text wf-node-text--concept">' + cname + '</span>';
  if (cSelected) h += '<span class="wf-status-pill" style="color:#1D9E75;border-color:#1D9E7533;">Selected</span>';
  h += '</div>';
  h += '<button class="wf-menu-btn" data-fn="openMenu" data-key="' + ckey + '" data-type="concept" data-conceptid="' + cid + '" data-owner="' + owner + '">&#8943;</button>';
  if (wf.menuNodeId === ckey) h += ctx.buildMenu('concept', { conceptId: cid, owner: owner, selected: cSelected });
  h += '</div>';
  if (!isCollapsed) {
    h += '<div class="wf-children">';
    if (units === undefined || units === null) {
      h += '<div class="wf-loading">Loading...</div>';
      if (units === undefined) loadUnits(cid);
    } else if (units.length === 0) {
      h += '<div class="wf-loading" style="color:#7a9aaa;">No units</div>';
    } else {
      for (var ui = 0; ui < units.length; ui++) {
        h += buildUnitRow(units[ui], cid);
      }
    }
    var _unassignedInline = ctx.unassignedRoomsCache[cid];
    if (_unassignedInline === undefined) {
      loadUnassignedRooms(cid);
    } else if (_unassignedInline && _unassignedInline.length > 0) {
      var _unassignedInlineHtml = '';
      for (var _urii = 0; _urii < _unassignedInline.length; _urii++) {
        _unassignedInlineHtml += buildRoomRow(_unassignedInline[_urii], '');
      }
      h += buildSectionNode('concept-unassigned:' + cid, 'unassigned', 'Unassigned Rooms (' + _unassignedInline.length + ')', _unassignedInlineHtml, _unassignedInline.length);
    }
    h += '</div>';
  }
  h += '</div>';
  return h;
}

export function buildUnitRow(unit, conceptId) {
  var f      = unit.fields;
  var uid    = unit.id;
  var uname  = f['Unit Type'] || f['Name'] || 'Unit';
  var ukey   = 'unit:' + uid;
  var isCollapsed = wf.collapsed[ukey] !== false;
  var levels = ctx.levelCache[uid];
  var hasChildren = levels === null || levels === undefined || levels.length > 0;
  var h = '';
  h += '<div class="wf-node wf-node--item" data-key="' + ukey + '"><div class="wf-row">';
  if (hasChildren) {
    h += '<button class="wf-triangle' + (isCollapsed ? '' : ' wf-triangle--open') + '" data-fn="toggleCollapse" data-key="' + ukey + '">'
      + '<span class="wf-tri-icon ' + (isCollapsed ? 'wf-tri-icon--right' : 'wf-tri-icon--down') + '"></span></button>';
  } else {
    h += '<span class="wf-triangle-spacer wf-triangle-spacer--hidden"></span>';
  }
  h += '<button class="wf-bullet wf-bullet--item" data-fn="zoomTo" data-level="unit-detail" data-unitid="' + uid + '" data-conceptid="' + conceptId + '"></button>';
  h += '<div class="wf-text-wrap"><span class="wf-node-text">' + uname + '</span></div>';
  h += '<button class="wf-menu-btn" data-fn="openMenu" data-key="' + ukey + '" data-type="unit" data-unitid="' + uid + '">&#8943;</button>';
  if (wf.menuNodeId === ukey) h += ctx.buildMenu('unit', { unitId: uid });
  h += '</div>';
  if (!isCollapsed) {
    h += '<div class="wf-children">';
    if (levels === undefined || levels === null) {
      h += '<div class="wf-loading">Loading...</div>';
      if (levels === undefined) loadLevels(uid);
    } else if (levels.length === 0) {
      h += '<div class="wf-loading" style="color:#7a9aaa;">No levels</div>';
    } else {
      for (var li = 0; li < levels.length; li++) {
        h += buildLevelRow(levels[li], uid, conceptId);
      }
    }
    h += '</div>';
  }
  h += '</div>';
  return h;
}

export function buildLevelRow(level, unitId, conceptId) {
  var f      = level.fields;
  var lid    = level.id;
  var lname  = f['Name'] || 'Level';
  var lkey   = 'level:' + lid;
  var isCollapsed = wf.collapsed[lkey] !== false;
  var rooms  = ctx.roomCache[lid];
  var hasChildren = rooms === null || rooms === undefined || rooms.length > 0;
  var h = '';
  h += '<div class="wf-node wf-node--item" data-key="' + lkey + '"><div class="wf-row">';
  if (hasChildren) {
    h += '<button class="wf-triangle' + (isCollapsed ? '' : ' wf-triangle--open') + '" data-fn="toggleCollapse" data-key="' + lkey + '">'
      + '<span class="wf-tri-icon ' + (isCollapsed ? 'wf-tri-icon--right' : 'wf-tri-icon--down') + '"></span></button>';
  } else {
    h += '<span class="wf-triangle-spacer wf-triangle-spacer--hidden"></span>';
  }
  h += '<button class="wf-bullet wf-bullet--item" data-fn="zoomTo" data-level="level-detail" data-levelid="' + lid + '" data-unitid="' + unitId + '"></button>';
  h += '<div class="wf-text-wrap"><span class="wf-node-text">' + lname + '</span></div>';
  h += '<button class="wf-menu-btn" data-fn="openMenu" data-key="' + lkey + '" data-type="level" data-levelid="' + lid + '" data-unitid="' + unitId + '" data-conceptid="' + conceptId + '">&#8943;</button>';
  if (wf.menuNodeId === lkey) h += ctx.buildMenu('level', { levelId: lid, unitId: unitId, conceptId: conceptId });
  h += '</div>';
  if (!isCollapsed) {
    h += '<div class="wf-children">';
    if (rooms === undefined || rooms === null) {
      h += '<div class="wf-loading">Loading...</div>';
      if (rooms === undefined) loadRooms(lid);
    } else if (rooms.length === 0) {
      h += '<div class="wf-loading" style="color:#7a9aaa;">No rooms</div>';
    } else {
      for (var ri = 0; ri < rooms.length; ri++) {
        h += buildRoomRow(rooms[ri], lid);
      }
    }
    h += '</div>';
  }
  h += '</div>';
  return h;
}

export function buildRoomRow(room, levelId) {
  var f      = room.fields;
  var rid    = room.id;
  var rdisplay = f['Room'] || f['Room Number and Name'] || 'Room';
  var rkey   = 'room:' + rid;
  var h = '';
  h += '<div class="wf-node wf-node--item" data-key="' + rkey + '"><div class="wf-row">';
  h += '<span class="wf-triangle-spacer wf-triangle-spacer--hidden"></span>';
  h += '<button class="wf-bullet wf-bullet--item" data-fn="openMenu" data-key="' + rkey + '" data-type="room" data-roomid="' + rid + '" data-levelid="' + levelId + '"></button>';
  h += '<div class="wf-text-wrap">';
  h += '<span class="wf-node-text">' + rdisplay + '</span>';
  h += '</div>';
  h += '<button class="wf-menu-btn" data-fn="openMenu" data-key="' + rkey + '" data-type="room" data-roomid="' + rid + '" data-levelid="' + levelId + '">&#8943;</button>';
  if (wf.menuNodeId === rkey) h += ctx.buildMenu('room', { roomId: rid, levelId: levelId });
  h += '</div></div>';
  return h;
}
